<template>
    <tr class="lms__superadmin_archived_list_table_item">
        <td class="lms__superadmin_archived_list_table_item_name">{{ archivedObjectName }}</td>
        <td class="lms__superadmin_archived_list_table_item_type">{{ toCapitalize(archivedObjectType) }}</td>
        <td class="lms__superadmin_archived_list_table_item_archivedat">
            {{ archivedObjectArchivedAtDate }}
            <component-text :size="'small'">Time: {{ archivedObjectArchivedAtTime }}</component-text>
        </td>
        <td class="lms__superadmin_archived_list_table_item_archivedby">{{ archivedObjectArchivedBy }}</td>
        <td class="lms__superadmin_archived_list_table_item_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :animate-loading="true"
                        :animate-loading-event-name="'restore-archived-object'"
                        :name="`lms-superadmin-archived-list-table-item-actions-restore-${ archivedObjectId }`"
                        @click="performRestoreArchivedObject"
                    >Restore</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { fromUTCDateTimeToLocalISOCustom, toCapitalize, toLocaleDateTime, toLocaleTime } from '@/functions'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'lms-superadmin-workspace-list-table-item',
  components: { ComponentText, ComponentButton },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    archivedObjectRouteName () {
      const type = this.item.itemType
      let routeName

      switch (type) {
        case 'workspace':
          routeName = 'lms-superadmin-workspace-edit'
          break
        case 'customer':
          routeName = 'lms-superadmin-customer-edit'
          break
        default:
          break
      }

      return routeName
    },
    archivedObjectId () {
      return this.item.id
    },
    archivedObjectSequenceId () {
      return this.item.sequenceId
    },
    archivedObjectName () {
      return this.item.itemName
    },
    archivedObjectType () {
      return this.item.itemType
    },
    archivedObjectArchivedAtTime () {
      return toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.archivedAt))
    },
    archivedObjectArchivedAtDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.archivedAt))
    },
    archivedObjectArchivedBy () {
      return this.item.archivedByName
    }
  },
  methods: {
    performRestoreArchivedObject () {
      this.$store.dispatch('lmsSuperadminDeletedObjectRemove', { sequenceId: this.archivedObjectSequenceId, type: this.archivedObjectType }).then(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: `${toCapitalize(this.archivedObjectType)} restore`,
          message: `${toCapitalize(this.archivedObjectType)} has been successfully restored.`,
          status: 'success'
        })
        this.$emit('emit', { message: 'emit-perform-get-items' })
      }).finally(() => {
        this.$eventBus.$emit('stop-restore-archived-object')
      }).catch(() => {
        this.$store.dispatch('defaultNotificationToastsAdd', {
          title: `${toCapitalize(this.archivedObjectType)} restore`,
          message: `${toCapitalize(this.archivedObjectType)} hasn't been restored.`,
          status: 'error'
        })
      })
    }
  }
}
</script>
